module.exports = __webpack_public_path__ + "img/Otium-favicon-64x64.1b8de84b.png";